class ReactAddContentItemVersionNote extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            stage: null,
            submit: this.props.submit
        };
    }

    show(stage, fn, newVersion) {
        var stateObject = {
            visible: true,
            stage: stage,
            newVersion: newVersion
        };

        if (fn) {
            stateObject.submit = fn;
        }

        this.setState(stateObject);
    };

    _hide() {
        this.setState({visible: false});
    };

    _save() {
        this.state.submit(this.state.stage, this.refs.note.value, this.state.newVersion);
        this._hide();
    };

    render() {
        var state = this.state;

        // Get centered or absolute popup class (available: 'popup-full-view', 'popup-centered', 'popup-absolute')
        var popupClass = $(document).scrollTop() > 100 ? 'popup-centered' : 'popup-absolute';

        return (
            <div className="global-react-popup-wrapper">
                <div
                    className={'global-react-popup add-content-item-version-note-popup ' + (popupClass) + (state.visible ? ' visible' : '')}>
                    <i className="close" onClick={this._hide.bind(this)}/>
                    <div className="content-wrapper">
                        <div className="content">
                            <div className="content-inner">
                                {state.stage ? <h2 className="title">Sending content to
                                    "{(state.stage && state.stage.name) ? state.stage.name : undefined}"</h2> : undefined}
                                <h3 className="sub-title">Write an optional note</h3>
                                <div className="form-holder">
                                    <form>
                                        <div className="field-group field-group-firstname even">
                                            <div className="field-group-inner">
                                                <label htmlFor="form-field-note-1">Note</label>
                                                <div className="field-holder">
                                                    <textarea required="required" type="text" ref="note" name="note"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="clearfix"></div>
                                        <div className="form-actions">
                                            <a onClick={this._save.bind(this)} className='btn btn-primary save' role="button"
                                               style={{marginRight: 10}}>Submit Changes</a>
                                            <a onClick={this._hide.bind(this)} className="btn btn-primary cancel"
                                               role="button">Cancel</a>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'global-react-popup-overlay ' + (popupClass) + (state.visible ? ' visible' : '')}></div>
            </div>
        )
    };
}

ReactAddContentItemVersionNote.displayName = 'ReactAddContentItemVersionNote';

ReactAddContentItemVersionNote.propTypes = {
    submit: PropTypes.func,
    stage: PropTypes.any
};